import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, Button, Typography, Container, CircularProgress } from '@mui/material';
import './EditProfile.css';
import logo from './assets/Logo.png';  // افزودن لوگو مشابه صفحه ثبت‌نام

function EditProfile() {
    const navigate = useNavigate();
    const [profileData, setProfileData] = useState({
        name: "",
        email: "",
        phone: "",
        address: "",
        postalCode: "",
        password: "",
        confirmPassword: ""
    });
    const [errors, setErrors] = useState({});
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);
    const [serviceUnavailable, setServiceUnavailable] = useState(false);

    // بارگذاری اطلاعات قبلی از localStorage به عنوان مقادیر پیش‌فرض
    useEffect(() => {
        const storedData = localStorage.getItem("userData");
        if (storedData) {
            const data = JSON.parse(storedData);
            setProfileData({
                name: data.name || data.Name || "",
                email: data.email || data.Email || "",
                phone: data.phone || data.Phone || "",
                address: data.address || data.Address || "",
                postalCode: data.postalCode || data.PostalCode || data["Postal Code"] || "",
                password: "",
                confirmPassword: ""
            });
        }
    }, []);

  const handleInputChange = (e) => {
    let { name, value } = e.target;

    // اصلاح کد پستی هنگام تایپ
    if (name === "postalCode") {
        value = value.toUpperCase().replace(/\s/g, "");
        if (value.length >= 3) {
            value = value.slice(0, 3) + (value.length > 3 ? " " + value.slice(3) : "");
        }
    } else if (name === "phone") {
        // حذف تمام خط تیره‌ها
        let digits = value.replace(/-/g, "");
        // محدود کردن به 10 رقم
        if (digits.length > 10) {
            digits = digits.slice(0, 10);
        }
        // افزودن خط تیره پس از سه رقم اول و سه رقم دوم
        if (digits.length > 3 && digits.length <= 6) {
            value = digits.slice(0, 3) + '-' + digits.slice(3);
        } else if (digits.length > 6) {
            value = digits.slice(0, 3) + '-' + digits.slice(3, 6) + '-' + digits.slice(6);
        } else {
            value = digits;
        }
    }

    setProfileData(prevState => ({
        ...prevState,
        [name]: value
    }));

    // پاکسازی خطای فیلد هنگام تایپ
    if (errors[name]) {
        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: ""
        }));
    }
};


    const validateFields = () => {
        const newErrors = {};
        if (!profileData.name.trim()) newErrors.name = "Name is required!";
        if (!profileData.email.trim()) {
            newErrors.email = "Email is required!";
        } else {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(profileData.email)) newErrors.email = "Invalid email format!";
        }

        if (!profileData.phone.trim()) {
            newErrors.phone = "Phone is required!";
        } else {
            const phoneRegex = profileData.phone.replace(/-/g, "");
            if (phoneRegex.length !==10) 
                newErrors.phone = "Phone number must be exactly 10 digits!";
        }

        if (!profileData.address.trim()) newErrors.address = "Address is required!";
        if (!profileData.postalCode.trim()) {
            newErrors.postalCode = "Postal code is required!";
        } else {
            const postalRegex = /^[A-Za-z]\d[A-Za-z][ ]?\d[A-Za-z]\d$/;
            if (!postalRegex.test(profileData.postalCode))
                newErrors.postalCode = "Invalid postal code format!";
        }
        if (profileData.password.trim()) {
            if (profileData.password.length < 6) {
                newErrors.password = "Password must be at least 6 characters!";
            }
            if (!profileData.confirmPassword.trim()) {
                newErrors.confirmPassword = "Please confirm your password!";
            } else if (profileData.password !== profileData.confirmPassword) {
                newErrors.confirmPassword = "Passwords do not match!";
            }
        }
        return newErrors;
    };

    const handleSave = async () => {
        setError("");
        setSuccess("");
        const validationErrors = validateFields();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        setLoading(true);
        try {
            const storedData = JSON.parse(localStorage.getItem("userData") || "{}");
            const postalPrefix = profileData.postalCode.replace(/\s/g, "").substring(0, 3).toUpperCase();
            const areaResponse = await fetch("https://carcure.ca/backend/check-working-area", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ postalPrefix })
            });
            const areaResult = await areaResponse.json();
            let serviceAvailability;
            if (!areaResult.found) {
                await fetch("https://carcure.ca/backend/update-client-info", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ name: profileData.name, status: "NA" })
                });
                setServiceUnavailable(true);
                setError("Thank you for updating your profile. Unfortunately, service is not currently available in your area. We will notify you as soon as service becomes available.");
                setLoading(false);
                return;
            } else {
                serviceAvailability = "Available";
            }
            const updateData = {
                Name: profileData.name,
                Phone: profileData.phone,
                Email: profileData.email,
                Address: profileData.address,
                "Postal Code": profileData.postalCode,
                oldEmail: storedData.email || profileData.email,
                Password: profileData.password.trim() ? profileData.password : storedData.password || "",
                "Service Availability": serviceAvailability
            };
            if (profileData.password.trim()) {
                updateData.confirmPassword = profileData.confirmPassword;
            }
            
            const response = await fetch("https://carcure.ca/backend/update-profile", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(updateData)
            });
            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.message);
            }
            setSuccess("Profile updated successfully!");
            localStorage.setItem("userData", JSON.stringify(updateData));
            setLoading(false);
            navigate(-1);
        } catch (err) {
            setError(err.message);
            setLoading(false);
        }
    };

    const handleCancel = () => {
        navigate(-1);
    };

    if (serviceUnavailable) {
        return (
            <Container maxWidth="sm" className="edit-profile-container">
                <Typography variant="h5" gutterBottom>
                    Thank you for updating your profile. Unfortunately, service is not currently available in your area. We will notify you as soon as service becomes available.
                </Typography>
                <Button variant="contained" color="primary" fullWidth onClick={handleCancel}>
                    Return to Home
                </Button>
            </Container>
        );
    }

    return (
        <Container maxWidth="sm" className="edit-profile-container">
            <button className="close-button" onClick={handleCancel}>×</button>
            {/* اضافه کردن لوگو به جای عنوان */}
            <div className="logo-container">
                <img src={logo} alt="Logo" className="login-logo" />
            </div>
            {error && <Typography color="error" align="center">{error}</Typography>}
            {success && <Typography color="primary" align="center">{success}</Typography>}
            <TextField 
                fullWidth 
                label="Name" 
                name="name" 
                value={profileData.name} 
                onChange={handleInputChange}
                margin="normal"
                error={Boolean(errors.name)}
                helperText={errors.name}
            />
            <TextField 
                fullWidth 
                label="Email" 
                name="email" 
                value={profileData.email} 
                onChange={handleInputChange}
                margin="normal"
                error={Boolean(errors.email)}
                helperText={errors.email}
            />
            <TextField 
                fullWidth 
                label="Phone" 
                name="phone" 
                value={profileData.phone} 
                onChange={handleInputChange}
                margin="normal"
                error={Boolean(errors.phone)}
                helperText={errors.phone}
            />
            <TextField 
                fullWidth 
                label="Address" 
                name="address" 
                value={profileData.address} 
                onChange={handleInputChange}
                margin="normal"
                error={Boolean(errors.address)}
                helperText={errors.address}
            />
          <TextField 
    fullWidth 
    label="Postal Code" 
    name="postalCode" 
    value={profileData.postalCode}  // مقدار اصلاح‌شده
    onChange={handleInputChange} 
    margin="normal"
    error={Boolean(errors.postalCode)}
    helperText={errors.postalCode}
/>

            <TextField 
                fullWidth 
                label="Password" 
                name="password" 
                type="password"
                value={profileData.password} 
                onChange={handleInputChange}
                margin="normal"
                error={Boolean(errors.password)}
                helperText={errors.password || "Leave empty if no change"}
            />
            <TextField 
                fullWidth 
                label="Confirm Password" 
                name="confirmPassword" 
                type="password"
                value={profileData.confirmPassword} 
                onChange={handleInputChange}
                margin="normal"
                error={Boolean(errors.confirmPassword)}
                helperText={errors.confirmPassword}
            />
           
           

 <div className="edit-buttons-container">
      <Button 
        variant="contained" 
        className="save-button"
        onClick={handleSave}
      >
        {loading ? <CircularProgress size={24} color="inherit" /> : "Save"}
      </Button>
      <Button 
        variant="contained" 
        className="cancel-btn"
        onClick={handleCancel}
      >
        Cancel
      </Button>
    </div>
  </Container>
);
}

export default EditProfile;
